import { IApplicationState } from '../../types/redux';

export function getFilters(state: IApplicationState) {
  return state.filter;
}
